<template>
  <div>

    <div class="row" v-if="editing">
      <div class="col-4">
        <label for="">{{ $t('insights.ui.timespan.label') }}</label>
        <select name="" class=form-control v-model="config.weekDifference" id="">
          <option value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
          <option value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
        </select>
      </div>
      <div class="col-3">
        <label for="title-planning">{{ $t('ui.title') }}</label>
        <input type="text" id="title-planning" class="form-control" v-model="config.title">
      </div>
      <div class="col-xs-3">
        <label for="filter-on">Filter</label>
        <select name="" class="form-control" v-model="config.filterByKey" id="">
          <option :value="null" v-show="!jobs.length" selected>{{ $t('ui.noData') }}</option>
          <option :value="key" :key="key" v-for="key in getUniqueJobKeys()">{{ getFormattedKey(key) }}</option>
        </select>
      </div>
    </div>


    <template v-if="!editing">
      <div class="row">
        <div class="col-4">
          <label for="">{{ $t('insights.ui.timespan.label') }}</label>
          <select name="" class=form-control v-model="config.weekDifference" id="">
            <option value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
            <option value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
          </select>
        </div>
        <div class="col-4">
          <label for="filter-value" v-if="!editing"> Filter</label>
          <select name="filter-value" class="form-control" v-model="config.filterByValue" id="">

            <option :value="null" v-if=!config.filterByKey>No data found or key set</option>

            <option v-if=config.filterByKey :value="null">{{ $t('ui.all') }}</option>
            <template v-if=config.filterByKey>
              <option :value="value" :key="value" v-for="value in getUniqueValues">{{ getFormattedValue(value) }}
              </option>
            </template>

          </select>
        </div>
      </div>
    </template>
    <div class="chart-container ">

      <horizontal-bar-chart style="position: relative;width: 100%; height: 100%"
                            :chartData="getChartData"
                            :options="getOptions"/>
    </div>

  </div>


</template>

<script>
import HorizontalBarChart from '@/components/insights/charts/horizontalBarChart.js'

import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";

export default {
  name: "JobLogInsight",
  components: {
    HorizontalBarChart
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {
    return {
      jobs: [],
      config: {
        weekDifference: 0,
        filterByKey: null,
        filterByValue: null
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getJobs() {
      return this.jobs
    },
    getDownTimes() {
      let downTimes = this.downTimes
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
      return downTimes
    },
    getFilteredJobs() {
      return _.filter(this.downTimes, dt => {

        return dt[this.config.filterByKey] === this.config.filterByValue
      })
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false
              },
            },
          ],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function (label, index, labels) {
                return self.formattedColonTime(label, false)
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value)    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex > 0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0 ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
    getUniqueKeys() {
      return Object.keys(Object.assign({}, ...this.jobs));
    },

    getUniqueValues() {
      // should loop and get values if type
      let mappedValues = _.map(this.jobs, (job) => {
        if (job[this.config.filterByKey] && job[this.config.filterByKey].length && typeof job[this.config.filterByKey] == "object") {
          return _.uniq(job[this.config.filterByKey])
        }

        return job[this.config.filterByKey]
      })
      let res = _.flattenDeep(mappedValues).filter(val => {
        return val
      })

      return [...new Set(res)].sort();


    },
    getUniqueReasons() {
      let logReasons = []
      _.each(this.jobs, j => {
        _.each(j.logs, log => {
          if (log.reason) {
            logReasons.push(log.reason)
          }
        })
      })
      return _.uniq(logReasons)

    },
    getChartData() {
      let labels = this.getUniqueReasons
      let datasets = [
        {
          label: this.$root.$t('insights.filters.jobs.reasons'),
          backgroundColor: this.colors.downTimes.reasons,
          data: new Array(labels.length).fill(0)
        }]
      _.each(this.jobs, j => {
        _.each(j.logs, log => {
          if (log.reason) {
            let index = _.findIndex(labels, label => {
              // reasons seperated by pipeline
              if (log.reason) {
                return label === log.reason
              }
            })
            if (index >= 0) {
              datasets[0].data[index] += log.amount * log.timeInMs
            } else {
              datasets[0].data[index] = log.amount * log.timeInMs
            }
          }
        })
      })
      const arrayOfObj = labels.map(function (d, i) {
        return {
          label: d,
          data: datasets[0].data[i] || 0,
        }
      })

      const sortedArrayOfObj = arrayOfObj.sort(function (a, b) {
        return b.data - a.data
      })

      let newArrayLabel = []
      let newArrayData = []
      sortedArrayOfObj.forEach(function (d) {
        newArrayLabel.push(d.label)
        newArrayData.push(d.data)
      })
      datasets[0].data = newArrayData
      return {
        labels: newArrayLabel,
        datasets,
      }
    },
  },
  methods: {
    async getJobsFiltered() {
      let userClaims = this.getClaims
      let time = moment().startOf('week').add(parseInt(this.config.weekDifference), 'week')
      // let time = moment().startOf('week').add(-10, 'week')

      try {
        let jobs = (await this.$FBClient.firestore().collection('jobs')
            .where('companyId', '==', userClaims.companyId)
            .where('plannedDate', '>=', time.toDate())
            .where('plannedDate', '<=', moment().add(parseInt(this.config.weekDifference), 'week').endOf('week').toDate())
            // .where('logs','!=',[])
            .get()).docs.map(doc => {
          return doc.data()
        })
        this.jobs = _.filter(jobs, j => {
          return j.logs && j.logs.length > 0
        })
      } catch (e) {
        console.error(e)
      }
      return false
    }
  },
  watch: {
    'config.weekDifference'() {
      this.getJobsFiltered()
    }
  },
  created() {
    this.getJobsFiltered()
  }
}
</script>


<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>